import { useMemo } from "react";
import { useShiftDateMatcher } from "./useShiftDateMatcher";
import { ReadShiftReport } from "@/types/shiftReport";
import { UseQueryResult } from "@tanstack/react-query";

export const useDatePickerProps = (
  shiftReportQuery: UseQueryResult<ReadShiftReport>,
) => {
  const { getAllowedDatesMatcher } = useShiftDateMatcher();

  return useMemo(() => {
    const shiftReport = shiftReportQuery.data;
    return shiftReport
      ? {
          disabled: shiftReport
            ? getAllowedDatesMatcher(
                new Date(shiftReport.shift_date),
                shiftReport.shift_name,
              )
            : undefined,
          defaultMonth: shiftReport
            ? new Date(shiftReport.shift_date)
            : undefined,
        }
      : undefined;
  }, [getAllowedDatesMatcher, shiftReportQuery.data]);
};
